import { Chip, Tooltip } from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { BRAND } from "../../styles/theme";

const chipSx = { fontWeight: 700, fontSize: 11, height: 22 };

/** `AR#CMFP` → chip "AR · CMFP" (violeta claro). */
export function ProcessorChip({ value }: { value: string }) {
  const [cc, pp] = (value ?? "").split("#");
  return <Chip size="small" label={pp ? `${cc} · ${pp}` : value || "—"}
    sx={{ ...chipSx, bgcolor: BRAND.pendingBg, color: BRAND.pendingText }} />;
}

export function BoolChip({ value, yes, no }: { value: boolean; yes: string; no: string }) {
  return value
    ? <Chip size="small" label={yes} sx={{ ...chipSx, bgcolor: "#DCFCE7", color: "#166534" }} />
    : <Chip size="small" label={no}  sx={{ ...chipSx, bgcolor: "#EEE", color: "#555" }} />;
}

export function StatusChip({ kind, label }: { kind: "ok" | "bad" | "info" | "warn" | "neutral" | "primary"; label: string }) {
  const c = {
    ok:      { bg: "#DCFCE7", fg: "#166534" },
    bad:     { bg: "#FEE2E2", fg: "#B91C1C" },
    info:    { bg: "#DBEAFE", fg: "#1E40AF" },
    warn:    { bg: "#FFF6E0", fg: "#9A6700" },
    neutral: { bg: "#EEE",    fg: "#555" },
    primary: { bg: BRAND.pendingBg, fg: BRAND.pendingText },
  }[kind];
  return <Chip size="small" label={label} sx={{ ...chipSx, bgcolor: c.bg, color: c.fg }} />;
}

export function SystemChip() {
  return (
    <Tooltip title="Generated by the integrator — read only">
      <Chip size="small" icon={<LockIcon sx={{ fontSize: 12 }} />} label="system"
        sx={{ ...chipSx, bgcolor: "#EEE", color: "#555", "& .MuiChip-icon": { color: "#555" } }} />
    </Tooltip>
  );
}

/** Chip chiquito outlined (canal, versión de app). */
export function MetaChip({ label }: { label: string }) {
  return <Chip size="small" variant="outlined" label={label}
    sx={{ height: 18, fontSize: 10, fontWeight: 500, color: "text.secondary", ml: 0.75 }} />;
}

export const fmtMoney = (n: number) =>
  new Intl.NumberFormat("es-AR", { style: "currency", currency: "ARS", minimumFractionDigits: 2 }).format(n);

export const fmtDateTime = (iso?: string | null) => {
  if (!iso) return "—";
  const d = new Date(iso);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleString("en-GB", {
    day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
    timeZone: "America/Argentina/Buenos_Aires",
  });
};
